module.exports = __webpack_public_path__ + "static/media/SignUp2Wave.182b13ee.svg";